import {
  Data,
  GET_WORKSPACE_KEY_VALUES,
  sortToDTO,
  workspaceKeyValueFromDTO,
  WorkspaceKeyValueSliceDTO,
} from 'features/globalSetup/pages/GoogleAdManagerConnectionPage/api/workspaceKeyValues'
import { useQuery } from 'providers/tanstack-query/useQuery'
import { WorkspaceKeyValueSlice } from '../../types'
import { UseGetWorkspaceKeyValues, UseGetWorkspaceKeyValuesProps, Variables } from './types'

export const useGetWorkspaceKeyValues = ({
  sort,
}: UseGetWorkspaceKeyValuesProps): UseGetWorkspaceKeyValues => {
  const { data, isLoading } = useQuery<Variables, Data, WorkspaceKeyValueSlice[]>({
    options: {
      select: ({ workspaceKeyValues }: Data): WorkspaceKeyValueSlice[] =>
        workspaceKeyValues.map(
          (dto: WorkspaceKeyValueSliceDTO): WorkspaceKeyValueSlice => workspaceKeyValueFromDTO(dto),
        ),
    },
    query: GET_WORKSPACE_KEY_VALUES,
    variables: {
      sort: sortToDTO(sort),
    },
  })

  return {
    loading: isLoading,
    workspaceKeyValues: data ?? [],
  }
}
